import React from 'react';
import Drawer from '@atlaskit/drawer';

import { Create } from '@/components/composed/forms';
import { CreateEntityContext } from '@/controllers';
import WithFormOpenByQueryParams from '@/components/primitive/hocs/with-form-open-by-query-params';

function CreateEntityDrawer({
  isOpen,
  setIsOpen,
}: {
  setIsOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
  isOpen: boolean;
}) {
  const createEntityController = React.useContext(CreateEntityContext);
  const handleClose = () => setIsOpen(false);
  return (
    <WithFormOpenByQueryParams onOpen={() => setIsOpen(true)}>
      <Drawer isOpen={isOpen} onClose={handleClose} width="wide">
        <Create
          initialType={createEntityController.type}
          initialCapability={createEntityController.capability}
          onClose={handleClose}
        />
      </Drawer>
    </WithFormOpenByQueryParams>
  );
}

export default CreateEntityDrawer;
